export const CROPPING_MODAL_COMPONENT_NAME = 'Cropping Modal';
export const OUTCROPPING_COMPONENT_NAME = 'Outcropping';
